var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 73,
    viewBox: "0 0 58 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5009 3.74927H29.1072H11.128C7.1561 3.74927 3.93628 6.96909 3.93628 10.941V61.2827C3.93628 65.2547 7.1561 68.4744 11.128 68.4744H12.9259M34.5009 3.74927L54.2781 23.9759M34.5009 3.74927V20.38C34.5009 22.366 36.1108 23.9759 38.0968 23.9759H54.2781M54.2781 23.9759V28.0212V36.1119V61.2827C54.2781 65.2547 51.0584 68.4744 47.0864 68.4744H45.2885",
    stroke: "#4048AE",
    strokeWidth: 7.19168,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1073 68.4743V39.7075M29.1073 39.7075L38.0969 48.6971M29.1073 39.7075L20.1177 48.6971",
    stroke: "#4048AE",
    strokeWidth: 7.19168,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.290ea798e4b8b282ba1fba01578a4578.svg";
export { ForwardRef as ReactComponent };